module.exports = __webpack_public_path__ + "img/antes_despues_90.3f9448e0.png";